// extracted by mini-css-extract-plugin
export var defaultWrapper = "_lr-3";
export var downloadButton = "_lr-4";
export var fileContainer = "_lr-9 _lr-7";
export var fileContainerBase = "_lr-7";
export var fileContainerFixedHeight = "_lr-8 _lr-7";
export var fileInfo = "_lr-5";
export var fileInfoWidthRestricted = "_lr-6";
export var fileType = "_lr-1";
export var fileTypeName = "_lr-2";
export var image = "_lr-0";
export var link = "_lr-b";
export var overflowEllipsis = "_lr-a";